import React from "react";

class IconsForEverythingHeader extends React.PureComponent {
    render() {
        let lightFontStyle = {
            fontFamily: "Light-45,Helvetica Neue,Helvetica,Arial,sans-serif",
            fontSize: "14px"
        };

        return (
            <header className="icons-header container row">
                <div className="col-xs-12">
                    <h1 className="font-xxlarge">Icons for everything</h1>
                    <p className="margin-b-l" style={lightFontStyle}>
                        Over 2 Million curated icons, created by a global
                        community
                    </p>
                </div>
            </header>
        );
    }
}

export default IconsForEverythingHeader;
